module.exports = __webpack_public_path__ + "static/media/cert7.d1d8aac5.jpeg";